export default function installBsDirectives(Vue) {
  Vue.directive('test');
}
